var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignCenter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 41,
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.911621,
    width: 35,
    height: 39,
    rx: 7.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.911621,
    width: 35,
    height: 39,
    rx: 7.5,
    stroke: "#E5E7EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12587_104211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 13.0785H27.4167C27.6598 13.0785 27.8929 12.9819 28.0648 12.81C28.2368 12.6381 28.3333 12.4049 28.3333 12.1618C28.3333 11.9187 28.2368 11.6855 28.0648 11.5136C27.8929 11.3417 27.6598 11.2451 27.4167 11.2451H10.9167C10.6736 11.2451 10.4404 11.3417 10.2685 11.5136C10.0966 11.6855 10 11.9187 10 12.1618C10 12.4049 10.0966 12.6381 10.2685 12.81C10.4404 12.9819 10.6736 13.0785 10.9167 13.0785Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9167 18.5785H24.9167C25.1598 18.5785 25.3929 18.4819 25.5648 18.31C25.7368 18.1381 25.8333 17.9049 25.8333 17.6618C25.8333 17.4187 25.7368 17.1855 25.5648 17.0136C25.3929 16.8417 25.1598 16.7451 24.9167 16.7451H13.9167C13.6736 16.7451 13.4404 16.8417 13.2685 17.0136C13.0966 17.1855 13 17.4187 13 17.6618C13 17.9049 13.0966 18.1381 13.2685 18.31C13.4404 18.4819 13.6736 18.5785 13.9167 18.5785Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 24.0785H27.4167C27.6598 24.0785 27.8929 23.9819 28.0648 23.81C28.2368 23.6381 28.3333 23.4049 28.3333 23.1618C28.3333 22.9187 28.2368 22.6855 28.0648 22.5136C27.8929 22.3417 27.6598 22.2451 27.4167 22.2451H10.9167C10.6736 22.2451 10.4404 22.3417 10.2685 22.5136C10.0966 22.6855 10 22.9187 10 23.1618C10 23.4049 10.0966 23.6381 10.2685 23.81C10.4404 23.9819 10.6736 24.0785 10.9167 24.0785Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9167 29.5785H24.9167C25.1598 29.5785 25.3929 29.4819 25.5648 29.31C25.7368 29.1381 25.8333 28.9049 25.8333 28.6618C25.8333 28.4187 25.7368 28.1855 25.5648 28.0136C25.3929 27.8417 25.1598 27.7451 24.9167 27.7451H13.9167C13.6736 27.7451 13.4404 27.8417 13.2685 28.0136C13.0966 28.1855 13 28.4187 13 28.6618C13 28.9049 13.0966 29.1381 13.2685 29.31C13.4404 29.4819 13.6736 29.5785 13.9167 29.5785Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12587_104211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 10.4116)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/align-center.e9ad4dd627af236e6091fdd210615fe8.svg";
export { ForwardRef as ReactComponent };